import React, { Component } from 'react'
import * as XLSX from 'xlsx'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import { Link } from 'react-router-dom'

const T = {
  bg: '#f1f5f9', card: '#ffffff', border: '#e8edf5',
  blue: '#3b82f6', blueD: '#2563eb', navy: '#0f172a',
  txt: '#1e293b', txt2: '#64748b', muted: '#94a3b8',
  green: '#16a34a', greenBg: '#f0fdf4', greenBdr: '#bbf7d0',
  red: '#dc2626', redBg: '#fef2f2', redBdr: '#fecaca',
  warn: '#f59e0b', warnBg: '#fffbeb', warnBdr: '#fde68a',
  r: 16, rsm: 10,
  shadow: '0 1px 3px rgba(15,23,42,.06)',
  shadowMd: '0 4px 16px rgba(15,23,42,.08)',
  font: "'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"
}

const S = {
  page: { background: T.bg, minHeight: '100vh', fontFamily: T.font, color: T.txt },
  header: {
    background: T.card, borderBottom: `1px solid ${T.border}`,
    padding: '20px 32px', display: 'flex', alignItems: 'center',
    gap: 12, position: 'sticky', top: 0, zIndex: 10, boxShadow: T.shadow
  },
  btnBack: {
    background: 'none', border: `1px solid ${T.border}`, borderRadius: T.rsm,
    padding: '8px 14px', cursor: 'pointer', color: T.txt2,
    fontSize: 14, display: 'flex', alignItems: 'center', gap: 6
  },
  btnXlsx: {
    background: T.greenBg, border: `1px solid ${T.greenBdr}`, borderRadius: T.rsm,
    padding: '8px 16px', cursor: 'pointer', color: T.green,
    fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6,
    marginLeft: 'auto'
  },
  title: { fontSize: 22, fontWeight: 700, color: T.navy, margin: 0 },
  content: { maxWidth: 1200, margin: '0 auto', padding: '28px 24px' },
  card: {
    background: T.card, borderRadius: T.r, border: `1px solid ${T.border}`,
    boxShadow: T.shadow, marginBottom: 20, overflow: 'hidden'
  },
  cardHeader: {
    padding: '16px 24px', borderBottom: `1px solid ${T.border}`,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap'
  },
  cardTitle: { fontSize: 14, fontWeight: 600, color: T.txt2, textTransform: 'uppercase', letterSpacing: '.06em' },
  filtersRow: { display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' },
  filterBox: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 200 },
  label: { fontSize: 11, fontWeight: 600, color: T.muted, textTransform: 'uppercase', letterSpacing: '.07em' },
  multiSelect: { position: 'relative' },
  msControl: {
    minHeight: 40, padding: '6px 10px', border: `1px solid ${T.border}`,
    borderRadius: T.rsm, background: T.card, cursor: 'pointer',
    display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center', minWidth: 220
  },
  msInput: {
    border: 'none', outline: 'none', fontSize: 13, color: T.txt,
    background: 'transparent', flex: 1, minWidth: 80
  },
  msDropdown: {
    position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
    background: T.card, border: `1px solid ${T.border}`, borderRadius: T.rsm,
    boxShadow: T.shadowMd, maxHeight: 220, overflowY: 'auto', marginTop: 4
  },
  msOption: {
    padding: '8px 12px', cursor: 'pointer', fontSize: 13,
    display: 'flex', alignItems: 'center', gap: 8,
    transition: 'background .1s'
  },
  msTag: {
    background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 20,
    padding: '2px 8px', fontSize: 12, fontWeight: 500, color: T.blue,
    display: 'flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap'
  },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: {
    padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700,
    color: T.txt2, textTransform: 'uppercase', letterSpacing: '.07em',
    background: '#f8fafc', borderBottom: `2px solid ${T.border}`,
    whiteSpace: 'nowrap'
  },
  thR: {
    padding: '10px 14px', textAlign: 'right', fontSize: 11, fontWeight: 700,
    color: T.txt2, textTransform: 'uppercase', letterSpacing: '.07em',
    background: '#f8fafc', borderBottom: `2px solid ${T.border}`,
    whiteSpace: 'nowrap'
  },
  td: { padding: '11px 14px', borderBottom: `1px solid ${T.border}`, color: T.txt, verticalAlign: 'middle' },
  tdR: { padding: '11px 14px', borderBottom: `1px solid ${T.border}`, color: T.txt, verticalAlign: 'middle', textAlign: 'right', fontVariantNumeric: 'tabular-nums' },
  tdMuted: { padding: '11px 14px', borderBottom: `1px solid ${T.border}`, color: T.txt2, verticalAlign: 'middle', fontSize: 12 },
  tdTotal: { padding: '12px 14px', color: T.navy, fontWeight: 700, textAlign: 'right', fontVariantNumeric: 'tabular-nums', borderTop: `2px solid ${T.border}` },
  spinner: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '80px 0', flexDirection: 'column', gap: 16
  },
  noData: { padding: '40px', textAlign: 'center', color: T.muted, fontSize: 14 },
  statCard: {
    background: T.card, borderRadius: T.rsm, border: `1px solid ${T.border}`,
    padding: '16px 20px', flex: 1, minWidth: 160
  },
  statLabel: { fontSize: 11, fontWeight: 600, color: T.muted, textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 6 },
  statValue: { fontSize: 22, fontWeight: 700, color: T.navy },
  badge: (c, b, bd) => ({
    display: 'inline-flex', alignItems: 'center',
    padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600,
    color: c, background: b, border: `1px solid ${bd}`
  }),
}

function formatMoney(amount) {
  if (amount === null || amount === undefined || amount === '' || isNaN(amount)) return '—'
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount)
}

// MultiSelect reutilizable
class MultiSelect extends Component {
  constructor(props) {
    super(props)
    this.state = { open: false, query: '' }
    this.containerRef = React.createRef()
    this.inputRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutside)
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutside)
  }
  handleOutside = (e) => {
    if (this.containerRef.current && !this.containerRef.current.contains(e.target))
      this.setState({ open: false, query: '' })
  }

  toggle(item) {
    const { selected, onChange, valueKey } = this.props
    const ids = selected.map(s => s[valueKey])
    if (ids.includes(item[valueKey]))
      onChange(selected.filter(s => s[valueKey] !== item[valueKey]))
    else
      onChange([...selected, item])
  }

  render() {
    const { options, selected, labelFn, placeholder, valueKey } = this.props
    const { open, query } = this.state
    const selectedIds = selected.map(s => s[valueKey])
    const filtered = options.filter(o => labelFn(o).toLowerCase().includes(query.toLowerCase()))

    return (
      <div style={S.multiSelect} ref={this.containerRef}>
        <div style={S.msControl} onClick={() => { this.setState({ open: true }); this.inputRef.current?.focus() }}>
          {selected.map(s => (
            <span key={s[valueKey]} style={S.msTag}>
              {labelFn(s)}
              <span onMouseDown={e => { e.preventDefault(); e.stopPropagation(); this.toggle(s) }}
                style={{ cursor: 'pointer', fontSize: 14, lineHeight: 1 }}>×</span>
            </span>
          ))}
          <input ref={this.inputRef} style={S.msInput} placeholder={selected.length === 0 ? placeholder : ''}
            value={query} onChange={e => this.setState({ query: e.target.value, open: true })} />
        </div>
        {open && (
          <div style={S.msDropdown}>
            {filtered.length === 0
              ? <div style={{ padding: '10px 14px', color: T.muted, fontSize: 13 }}>Sin resultados</div>
              : filtered.map(o => (
                <div key={o[valueKey]} style={{ ...S.msOption, background: selectedIds.includes(o[valueKey]) ? '#eff6ff' : 'transparent' }}
                  onMouseDown={e => { e.preventDefault(); this.toggle(o) }}>
                  <div style={{
                    width: 16, height: 16, borderRadius: 4, flexShrink: 0,
                    border: `2px solid ${selectedIds.includes(o[valueKey]) ? T.blue : T.border}`,
                    background: selectedIds.includes(o[valueKey]) ? T.blue : 'transparent',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    {selectedIds.includes(o[valueKey]) && <span style={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>✓</span>}
                  </div>
                  <span style={{ fontSize: 13, color: T.txt }}>{labelFn(o)}</span>
                </div>
              ))
            }
          </div>
        )}
      </div>
    )
  }
}

class DomiciliosReporteCostoSociedadesCliente extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // NOTE: El endpoint devuelve un array de objetos. Estructura esperada por campo:
      // costoDomiciliosSociedadesClienteDtoArray: [{
      //   clienteId, nombreCliente,
      //   sociedadId, razonSocial, rfc,
      //   domicilioId, calle, colonia, municipio, estado,
      //   tipoGasto, cantidad, fecha, periodo, ejercicio,
      //   rentaMensual  (opcional)
      // }]
      // Si la estructura difiere, ajusta los nombres de campo en render()
      costoDomiciliosSociedadesClienteDtoArray: [],
      allSociedades: [],
      allClientes: [],
      selectedSociedades: [],
      selectedClientes: [],
      loading: true,
      errorMsg: '',
    }
  }

  componentDidMount() {
    Promise.all([
      ElementsDataService.retrieveAllElements('domicilios/gastos-sociedades-cliente/'),
      ElementsDataService.retrieveAllElements('sociedades'),
      ElementsDataService.retrieveAllElements('clientes'),
    ]).then(([costoRes, socRes, cliRes]) => {
      console.log('costoRes.data:', JSON.stringify(costoRes.data).slice(0,300))
      this.setState({
        costoDomiciliosSociedadesClienteDtoArray: Array.isArray(costoRes.data) ? costoRes.data : (costoRes.data?.content || costoRes.data?.data || costoRes.data?.elements || []),
        allSociedades: socRes.data || [],
        allClientes: cliRes.data || [],
        loading: false,
      })
    }).catch(() => {
      this.setState({ loading: false, errorMsg: 'Error al cargar los datos.' })
    })
  }

  getFiltered() {
    const { costoDomiciliosSociedadesClienteDtoArray, selectedSociedades, selectedClientes } = this.state
    const socIds = selectedSociedades.map(s => s.id)
    const cliIds = selectedClientes.map(c => c.id)

    if (!Array.isArray(costoDomiciliosSociedadesClienteDtoArray)) return []
    return costoDomiciliosSociedadesClienteDtoArray.filter(row => {
      const socMatch = socIds.length === 0 || socIds.includes(row.sociedadId)
      const cliMatch = cliIds.length === 0 || cliIds.includes(row.clienteId)
      return socMatch && cliMatch
    })
  }

  exportExcel(rows) {
    const data = rows.map(r => ({
      'Cliente':        r.nombreCliente || '',
      'Razón Social':   r.razonSocial   || '',
      'RFC':            r.rfc           || '',
      'Domicilio':      r.calle ? `${r.calle}${r.colonia ? ', ' + r.colonia : ''}` : '',
      'Municipio':      r.municipio     || '',
      'Estado':         r.estado        || '',
      'Concepto':       r.tipoGasto     || '',
      'Periodo':        r.periodo       || '',
      'Ejercicio':      r.ejercicio     || '',
      'Renta Mensual':  r.rentaMensual  ?? '',
      'Gasto':          r.cantidad      ?? '',
    }))

    const ws = XLSX.utils.json_to_sheet(data)
    const colWidths = [20, 30, 15, 30, 18, 16, 20, 12, 10, 16, 14]
    ws['!cols'] = colWidths.map(w => ({ wch: w }))

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Costos Domicilios')
    const date = new Date().toISOString().slice(0, 10)
    XLSX.writeFile(wb, `CostoDomiciliosSociedades_${date}.xlsx`)
  }

  render() {
    const { allSociedades, allClientes, selectedSociedades, selectedClientes, loading, errorMsg } = this.state

    const filtered = this.getFiltered()
    const totalGastos = filtered.reduce((acc, r) => acc + (Number(r.cantidad) || 0), 0)
    const totalRenta = filtered.reduce((acc, r) => acc + (Number(r.rentaMensual) || 0), 0)

    // Clientes únicos en resultado
    const uniqueClientes = [...new Set(filtered.map(r => r.clienteId))].length
    const uniqueSociedades = [...new Set(filtered.map(r => r.sociedadId))].length
    const uniqueDomicilios = [...new Set(filtered.map(r => r.domicilioId))].length

    return (
      <div style={S.page}>
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>

        {/* Header */}
        <div style={S.header}>
          <button style={S.btnBack} onClick={() => this.props.history.goBack()}>‹ Atrás</button>
          <div style={S.title}>Costos Domicilios por Sociedad y Cliente</div>
          <button style={S.btnXlsx} onClick={() => this.exportExcel(filtered)}>
            📥 Exportar Excel
          </button>
        </div>

        <div style={S.content}>
          {errorMsg && (
            <div style={{ background: T.redBg, border: `1px solid ${T.redBdr}`, borderRadius: T.rsm, padding: '12px 16px', color: T.red, fontSize: 14, marginBottom: 16 }}>
              ⚠️ {errorMsg}
            </div>
          )}

          {loading ? (
            <div style={S.spinner}>
              <div style={{ width: 36, height: 36, border: `3px solid ${T.border}`, borderTopColor: T.blue, borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
              <span style={{ color: T.txt2, fontSize: 14 }}>Cargando reporte...</span>
            </div>
          ) : (<>

            {/* Filtros */}
            <div style={S.card}>
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>🔍 Filtros</span>
                {(selectedClientes.length > 0 || selectedSociedades.length > 0) && (
                  <button style={{ ...S.btnBack, fontSize: 12 }}
                    onClick={() => this.setState({ selectedClientes: [], selectedSociedades: [] })}>
                    Limpiar filtros
                  </button>
                )}
              </div>
              <div style={{ padding: '16px 24px' }}>
                <div style={S.filtersRow}>
                  <div style={S.filterBox}>
                    <label style={S.label}>Clientes</label>
                    <MultiSelect
                      options={allClientes}
                      selected={selectedClientes}
                      onChange={v => this.setState({ selectedClientes: v })}
                      labelFn={o => o.nombreCliente}
                      valueKey="id"
                      placeholder="Todos los clientes"
                    />
                  </div>
                  <div style={S.filterBox}>
                    <label style={S.label}>Sociedades</label>
                    <MultiSelect
                      options={allSociedades}
                      selected={selectedSociedades}
                      onChange={v => this.setState({ selectedSociedades: v })}
                      labelFn={o => `${o.razonSocial} ${o.rfc}`}
                      valueKey="id"
                      placeholder="Todas las sociedades"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
              {[
                { label: 'Registros', value: filtered.length },
                { label: 'Clientes', value: uniqueClientes },
                { label: 'Sociedades', value: uniqueSociedades },
                { label: 'Domicilios', value: uniqueDomicilios },
                { label: 'Total Gastos', value: formatMoney(totalGastos) },
                { label: 'Total Renta', value: formatMoney(totalRenta) },
              ].map(s => (
                <div key={s.label} style={S.statCard}>
                  <div style={S.statLabel}>{s.label}</div>
                  <div style={{ ...S.statValue, fontSize: typeof s.value === 'string' ? 16 : 22 }}>{s.value}</div>
                </div>
              ))}
            </div>

            {/* Tabla */}
            <div style={S.card}>
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>📋 Detalle de Gastos</span>
                <span style={{ fontSize: 13, color: T.txt2, fontWeight: 600 }}>{filtered.length} registro{filtered.length !== 1 ? 's' : ''}</span>
              </div>
              {filtered.length === 0
                ? <div style={S.noData}>Sin resultados con los filtros seleccionados</div>
                : <div style={{ overflowX: 'auto' }}>
                    <table style={S.table}>
                      <thead>
                        <tr>
                          <th style={S.th}>Cliente</th>
                          <th style={S.th}>Razón Social</th>
                          <th style={S.th}>RFC</th>
                          <th style={S.th}>Domicilio</th>
                          <th style={S.th}>Municipio / Estado</th>
                          <th style={S.th}>Concepto</th>
                          <th style={S.th}>Periodo</th>
                          <th style={S.thR}>Renta Mensual</th>
                          <th style={S.thR}>Gasto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtered.map((r, i) => (
                          <tr key={i} style={{ background: i % 2 === 0 ? T.card : '#fafbfc' }}>
                            <td style={S.td}>{r.nombreCliente || '—'}</td>
                            <td style={S.td}>
                              {r.sociedadId
                                ? <Link to={`/sociedades/reportes/${r.sociedadId}`}
                                    style={{ color: T.blue, textDecoration: 'none', fontWeight: 500 }}>
                                    {r.razonSocial}
                                  </Link>
                                : r.razonSocial || '—'
                              }
                            </td>
                            <td style={S.tdMuted}>{r.rfc || '—'}</td>
                            <td style={S.td}>
                              {r.domicilioId
                                ? <Link to={`/domicilios/reportes/${r.domicilioId}`}
                                    style={{ color: T.blue, textDecoration: 'none' }}>
                                    {r.calle}{r.colonia ? `, ${r.colonia}` : ''}
                                  </Link>
                                : r.calle || '—'
                              }
                            </td>
                            <td style={S.tdMuted}>
                              {[r.municipio, r.estado].filter(Boolean).join(', ') || '—'}
                            </td>
                            <td style={S.td}>{r.tipoGasto || '—'}</td>
                            <td style={S.tdMuted}>
                              {r.periodo && r.ejercicio ? `${r.periodo} ${r.ejercicio}` : r.periodo || r.ejercicio || '—'}
                            </td>
                            <td style={S.tdR}>{formatMoney(r.rentaMensual)}</td>
                            <td style={{ ...S.tdR, fontWeight: 600 }}>{formatMoney(r.cantidad)}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={7} />
                          <td style={S.tdTotal}>{formatMoney(totalRenta)}</td>
                          <td style={S.tdTotal}>{formatMoney(totalGastos)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
              }
            </div>

          </>)}
        </div>
      </div>
    )
  }
}

export default DomiciliosReporteCostoSociedadesCliente
